// @flow

import React, { Fragment } from 'react';
import { t } from 'Src/i18n';
import classnames from 'classnames';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { OfferPush } from 'Components/widgets/offers-push/OfferPush';
import { Slider } from 'Components/frameworks/slider/Slider';
import { TrackClick } from 'Tracking/track-click/TrackClick';

type Props = CMSOffersPush;

export const OffersPushLineNarrow = ({ title, seeMoreLabel, seeMoreLink, columns }: Props) => (
  <Fragment>
    {!!title && <LineTitle>{title}</LineTitle>}
    <div className="-mx-5 lg:mx-0 w-screen lg:w-full">
      <Slider
        cols={0}
        hasControls={false}
        nbItemsToScroll={1}
        scrollBackwardLabel={t('common.scrollBackward')}
        scrollForwardLabel={t('common.scrollForward')}
        scrollAreaClassName="overflow-hidden"
        scrollAreaContainerClassName="overflow-auto scroll-snap-area scroll-snap-type-x-mandatory"
        navPosition="center"
      >
        {columns.map((columnProps, index) => (
          <div
            className={classnames('flex-1 sm:w-1/3 rtl:ml-5', {
              'lg:rtl:ml-0': index === 0,
            })}
            style={{ width: '85vw', maxWidth: '380px' }}
            key={index}
          >
            <OfferPush {...columnProps} id={index + 1} />
          </div>
        ))}
        <div
          style={{ width: '20px', height: '1px', flexShrink: '0' }}
          className="lg:hidden rtl:-order-1"
        />
      </Slider>
    </div>

    {seeMoreLabel &&
      seeMoreLink && (
        <TrackClick
          as={DynamicLink}
          url={seeMoreLink}
          className="block mx-auto mt-4 text-center text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline"
          trackingData={{
            actionGA: 'main_push_offers',
            labelGA: 'seeMore',
          }}
        >
          {seeMoreLabel}
        </TrackClick>
      )}
  </Fragment>
);
